import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { TokenService } from '@services/token/token.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public user: BehaviorSubject<any>;

  constructor(public http: HttpClient, private tokenService: TokenService) {
    this.user = new BehaviorSubject(JSON.parse(localStorage.getItem('user')));
  }

  // Returning the value where it's needed
  get userData() {
    return this.user.value;
  }

  Login(credential: object): Observable<any> {
    return this.http
      .post<any>(`${environment.api}auth/user/login`, credential)
      .pipe(
        map((response) => {
          localStorage.setItem('user', JSON.stringify(response));
          if (response && response.data.tokens) {
            this.user.next(response);
          }
          return response;
        })
      );
  }

  Logout() {
    // remove user credential from chrome storage
    localStorage.removeItem('user');
    localStorage.clear();
    window.location.href = environment.forntend_url;
  }

  ForgotPassword(data: object): any {
    return this.http
      .post<any>(`${environment.api}auth/user/forgot-password`, data)
      .pipe(
        map((response: any) => {
          if (response) {
          }
          return response;
        })
      );
  }

  VerifyForgotPassword(data: object): any {
    return this.http
      .post<any>(`${environment.api}auth/user/verify-forgot-password`, data)
      .pipe(
        map((response: any) => {
          if (response) {
          }
          return response;
        })
      );
  }

  changePassword(payload: object) {
    return this.http.post(
      `${environment.pdiAPI}user/change-password`,
      payload,
      { headers: this.tokenService.getTokenHeader() }
    );
  }
}
